// src/utils/notificationRoutes.js

// This will be populated from the API
let NOTIFICATION_TYPE_ROUTES = {};

// Default routes for common types
const DEFAULT_ROUTES = {
  // Exhibition Module
  exhibition: "/exhibition-management",
  exhibition_member: "/exhibition-management",
  exhibition_member_assignment: "/exhibition-management",
  exhibition_member_acknowledgement: "/exhibition-management",
  visitor_detail: "/exhibition-management",

  // Tickets & Issuance
  ticket: "/raise-ticket",
  ticket_created: "/raise-ticket",
  ticket_updated: "/raise-ticket",
  ticket_update: "/raise-ticket",
  ticket_deleted: "/raise-ticket",
  ticket_acknowledged: "/raise-ticket",
  ticket_message: "/raise-ticket",
  ticket_message_updated: "/raise-ticket",
  new_ticket: "/raise-ticket",

  issuance: "/request-issuance",
  request_created: "/request-issuance",
  request_deleted: "/request-issuance",
  request_update: "/request-issuance",
  request_updated: "/request-issuance",
  new_request: "/request-issuance",
  request_acknowledged: "/request-issuance",

  // Asset Management
  asset_assign: "/asset-assign",
  new_asset_assign: "/asset-assign",
  asset_assign_created: "/asset-assign",
  asset_assign_acknowledged: "/asset-assign",
  asset_assign_returned: "/asset-assign",
  asset_assign_update: "/asset-assign",
  asset_assign_deleted: "/asset-assign",

  // Employee Module
  employee: "/employee",
  employee_log: "/employee-log",
  employee_location: "/locations",
  attendance: "/my-attendance",
  break_time_log: "/break-time-log",
  break_log: "/break-log",

  // My Stuff
  my_attachment: "/my-attachments",
  profile: "/profile",
  notifications: "/notifications",

  // Work & Tasks
  work_assign_task: "/work-task-assignment",
  work_task: "/work-task-assignment",
  sample_target: "/work-task-assignment",
  work_assign_dashboard: "/designing-dashboard",
  hourly_work_management: "/hourly-work-log",
  to_do_list: "/to-do-list",
  tealtik_category: "/todo-categories",
  work_task_notification: "/work-task-assignment",
  work_task_status_changed: "/work-task-assignment",
  work_task_assigned: "/work-task-assignment",
  work_subtask_assigned: "/work-task-assignment",
  work_subtask_status_changed: "/work-task-assignment",
  work_task_overdue: "/work-task-assignment",
  work_task_updated: "/work-task-assignment",
  work_subtask_updated: "/work-task-assignment",
  work_task_hourly_reminder: "/work-task-assignment",

  // Task Management
  task_created: "/to-do-list",
  task_updated: "/to-do-list",
  task_status_updated: "/to-do-list",
  task_reminder: "/to-do-list",
  task_daily_reminder: "/to-do-list",
  task_daily_email_reminder: "/to-do-list",
  task_daily_whatsapp_reminder: "/to-do-list",
  task_overdue: "/to-do-list",
  task_due_today: "/to-do-list",
  task_starting_today: "/to-do-list",
  task_hourly_reminder: "/to-do-list",
  task_weekday_reminder: "/to-do-list",

  // Item/Inventory Reminders
  item_daily_reminder: "/warranty-guarantee-management",
  item_reminder: "/warranty-guarantee-management",
  item_service: "/warranty-guarantee-management",
  item_daily_email_reminder: "/warranty-guarantee-management",
  item_daily_whatsapp_reminder: "/warranty-guarantee-management",

  // Leave Management
  leave_management: "/leave-management",
  leave_policy: "/leave-policy",
  leave_changed: "/leave-management",
  employee_leave: "/leave-management",

  // Canteen
  menu: "/canteen/menu",
  canteen_log: "/canteen-logs",
  canteen_order_log: "/order-list",

  // Inventory & Stock
  inventory: "/inventory",
  inventory_log: "/inventory-log",
  stock: "/stock",
  category: "/category",
  sub_category: "/subcategory",
  vendor: "/vendor",
  warranty_guarantee: "/warranty-guarantee-management",

  // Reports
  reports: "/reports",
  inventory_summary: "/reports/inventory-summary",
  stock_movement: "/reports/stock-movement",
  low_stock_alert: "/reports/low-stock",
  expired_items: "/reports/expired-items",
  consumption_trend: "/reports/consumption-trend",
  department_consumption: "/reports/department-consumption",
  purchase_history: "/reports/purchase-history",
  price_variation: "/reports/price-variation",
  asset_master: "/reports/asset-master",
  break_summary: "/reports/break-summary",
  break_duration: "/reports/break-duration",
  irregular_breaks: "/reports/irregular-breaks",
  time_deviation: "/reports/time-deviation",
  tickets_overview: "/reports/tickets-overview",
  tat_compliance: "/reports/tat-compliance",
  escalations: "/reports/escalations",
  department_tickets: "/reports/department-tickets",
  recurring_issues: "/reports/recurring-issues",
  handler_productivity: "/reports/handler-productivity",
  canteen_orders: "/reports/canteen-orders",
  popular_items: "/reports/popular-items",
  canteen_finance: "/reports/canteen-finance",
  ingredient_stock: "/reports/ingredient-stock",

  // Escalation
  escalation: "/reports/escalations",
  escalation_incoming: "/reports/escalations",
  escalation_outgoing: "/reports/escalations",
  escalation_received: "/reports/escalations",
  escalation_sent: "/reports/escalations",
  escalation_history: "/escalation-history-log",

  // Other Modules
  role: "/role",
  department: "/department",
  company: "/company",
  password_reset_questions: "/security-question",
  password_reset_answer: "/profile",
  password_reset: "/forgot-password",
  suggestions: "/suggestion",
  new_suggestion: "/suggestion",
  suggestion: "/suggestion",
  feedback: "/feedback",
  customer_profile: "/customer-profile",
  employee_wallet_history: "/update-wallet",
  activity_logs: "/general-log",
  permission_log: "/permissions-log",
  interview_form: "/interview-applications",
  contact_details: "/contact-details",
  work_task_report: "/reports/work-task-report",
  my_team: "/my-teams",
  settings: "/settings",
  hourly_work: "/hourly-work-log",
  new_contact: "/contact-details",
  not_on_desk: "/my-attendance",
  not_submitted_hourly_task: "/hourly-work-log",
  lead_created: "/lead-management/leads",
  lead_status_changed: "/lead-management/leads",
  lead_product_added: "/lead-management/leads",
  lead_product_removed: "/lead-management/leads",
  agency: "/agencies",
  visitor: "/visitors",

  // Authentication & System
  login: "/dashboard",
  logout: "/login",
  first_login_setup: "/security-setup",
  general: "/dashboard",
  system: "/dashboard",
  import_completed: "/dashboard",
  permission_changed: "/dashboard",
};

/**
 * Initialize notification routes with choices from API
 * Call this once when the app loads
 */
export const initNotificationRoutes = (choices) => {
  if (!choices || !Array.isArray(choices)) return;

  // Map each notification type to a route based on its value
  choices.forEach((choice) => {
    const typeValue = choice.value;
    const typeLabel = choice.label;

    // Determine route based on type value - PRIORITIZE DEFAULT_ROUTES first
    if (DEFAULT_ROUTES[typeValue]) {
      NOTIFICATION_TYPE_ROUTES[typeValue] = DEFAULT_ROUTES[typeValue];
    } else if (
      typeValue.includes("exhibition") ||
      typeLabel.includes("Exhibition")
    ) {
      NOTIFICATION_TYPE_ROUTES[typeValue] = "/exhibition-management";
    } else if (typeValue.includes("ticket") || typeLabel.includes("Ticket")) {
      NOTIFICATION_TYPE_ROUTES[typeValue] = "/raise-ticket";
    } else if (
      typeValue.includes("employee") ||
      typeLabel.includes("Employee")
    ) {
      NOTIFICATION_TYPE_ROUTES[typeValue] = "/employee";
    } else if (
      typeValue.includes("inventory") ||
      typeLabel.includes("Inventory")
    ) {
      NOTIFICATION_TYPE_ROUTES[typeValue] = "/inventory";
    } else if (typeValue.includes("my_attachment")) {
      NOTIFICATION_TYPE_ROUTES[typeValue] = "/my-attachments";
    } else if (typeValue.includes("role")) {
      NOTIFICATION_TYPE_ROUTES[typeValue] = "/role";
    } else if (typeValue.includes("department")) {
      NOTIFICATION_TYPE_ROUTES[typeValue] = "/department";
    } else if (typeValue.includes("company")) {
      NOTIFICATION_TYPE_ROUTES[typeValue] = "/company";
    } else if (typeValue.includes("category")) {
      NOTIFICATION_TYPE_ROUTES[typeValue] = "/category";
    } else if (typeValue.includes("sub_category")) {
      NOTIFICATION_TYPE_ROUTES[typeValue] = "/subcategory";
    } else if (typeValue.includes("vendor")) {
      NOTIFICATION_TYPE_ROUTES[typeValue] = "/vendor";
    } else if (typeValue.includes("suggestion")) {
      NOTIFICATION_TYPE_ROUTES[typeValue] = "/suggestion";
    } else if (typeValue.includes("feedback")) {
      NOTIFICATION_TYPE_ROUTES[typeValue] = "/feedback";
    } else if (typeValue.includes("leave_policy")) {
      NOTIFICATION_TYPE_ROUTES[typeValue] = "/leave-policy";
    } else if (typeValue.includes("employee_leave")) {
      NOTIFICATION_TYPE_ROUTES[typeValue] = "/leave-management";
    } else if (typeValue.includes("hourly_work")) {
      NOTIFICATION_TYPE_ROUTES[typeValue] = "/hourly-work-log";
    } else if (typeValue.includes("new_contact")) {
      NOTIFICATION_TYPE_ROUTES[typeValue] = "/contact-details";
    } else if (typeValue.includes("employee_location")) {
      NOTIFICATION_TYPE_ROUTES[typeValue] = "/locations";
    } else if (typeValue.includes("interview_form")) {
      NOTIFICATION_TYPE_ROUTES[typeValue] = "/interview-applications";
    } else if (typeValue.includes("asset_assign")) {
      NOTIFICATION_TYPE_ROUTES[typeValue] = "/asset-assign";
    } else if (typeValue.includes("report")) {
      NOTIFICATION_TYPE_ROUTES[typeValue] = "/reports";
    } else if (typeValue.includes("escalation")) {
      NOTIFICATION_TYPE_ROUTES[typeValue] = "/reports/escalations";
    } else if (typeValue.includes("task") || typeValue.includes("work_task")) {
      NOTIFICATION_TYPE_ROUTES[typeValue] = "/work-task-assignment";
    } else if (typeValue.includes("password_reset")) {
      NOTIFICATION_TYPE_ROUTES[typeValue] = "/forgot-password";
    } else if (typeValue.includes("login") || typeValue.includes("logout")) {
      NOTIFICATION_TYPE_ROUTES[typeValue] = "/dashboard";
    } else {
      // Default route for unknown types
      NOTIFICATION_TYPE_ROUTES[typeValue] = "/dashboard";
    }
  });
};

// Pages that open / highlight the record given as ?open=<id> (see WorkTaskBoard's drawer,
// RaiseTicketPage's ticket detail, and DataTable's row highlight on the other lists).
const OPENS_RECORD = new Set([
  "/work-task-assignment", "/raise-ticket", "/request-issuance", "/asset-assign",
  "/to-do-list", "/warranty-guarantee-management", "/leave-management", "/agencies",
  "/visitors", "/interview-applications", "/suggestion", "/lead-management/leads",
  "/contact-details", "/my-attachments",
]);

// Exhibition notifications are about a member / assignment / acknowledgement / visitor of
// an exhibition: the record to open is the exhibition.
const EXHIBITION_TYPES = new Set([
  "exhibition_member", "exhibition_member_assignment", "exhibition_member_acknowledgement", "visitor_detail",
]);

const usableId = (v) => {
  if (v === null || v === undefined) return null;
  const s = String(v).trim();
  return s && s !== "null" && s !== "None" && s !== "undefined" ? s : null;
};

/**
 * Get the route path for a notification
 * @param {Object} notification - The notification object (REST row, socket row, or a push's data)
 * @returns {string} - The route path
 */
export const getNotificationPath = (notification) => {
  if (!notification || !notification.type) {
    return "/dashboard";
  }
  const nf = notification.notifiable || {};
  // Several modules send type "general" and say what it is about in notifiable.type
  // (agency, visitor, interview_form, sample_target, low stock on a sub-category ...).
  let type = notification.type;
  if (type === "general" && nf.type) {
    type = nf.type === "sub_category" ? "low_stock_alert" : String(nf.type).toLowerCase();
  }

  const base =
    NOTIFICATION_TYPE_ROUTES[type] ||
    DEFAULT_ROUTES[type] ||
    "/dashboard";

  // The record the notification is about: the REST list and the socket carry it in
  // `notifiable` (the server never fills object_id there); live sends and pushes may carry
  // object_id / data.id.
  const id = usableId(
    EXHIBITION_TYPES.has(type) ? nf.exhibition_id : nf.id
  ) || usableId(notification.object_id) || usableId(notification.target_id)
    || usableId(notification.data?.id) || usableId(notification.data?.object_id);
  if (id && OPENS_RECORD.has(base)) {
    return `${base}?open=${encodeURIComponent(id)}`;
  }
  return base;
};

/**
 * Get the display name for notification type
 * @param {string} type - The notification type
 * @returns {string} - Human readable name
 */
export const getNotificationTypeName = (type) => {
  const typeNames = {
    // Exhibition
    exhibition: "Exhibition",
    exhibition_member: "Exhibition Member",
    exhibition_member_assignment: "Team Assignment",
    exhibition_member_acknowledgement: "Acknowledgement",
    visitor_detail: "Visitor",

    // Tickets & Issuance
    ticket: "Ticket",
    ticket_created: "Ticket Created",
    ticket_updated: "Ticket Updated",
    ticket_acknowledged: "Ticket Resolved",
    new_ticket: "New Ticket",
    issuance: "Issuance",
    request_created: "Request Created",
    request_acknowledged: "Request Acknowledged",

    // Asset
    asset_assign: "Asset Assignment",
    new_asset_assign: "New Asset",
    asset_assign_returned: "Asset Returned",

    // Employee
    employee: "Employee",
    employee_leave: "Leave Request",
    hourly_work: "Hourly Work",
    new_contact: "New Contact",

    // Tasks
    task_created: "Task Created",
    task_updated: "Task Updated",
    task_overdue: "Task Overdue",
    task_due_today: "Due Today",
    task_starting_today: "Starting Today",
    work_task_assigned: "Work Task Assigned",

    // Inventory
    inventory: "Inventory",
    low_stock_alert: "Low Stock Alert",
    item_service: "Item Service",

    // Lead Management
    lead: "Lead",
    lead_status_changed: "Lead Status Changed",
    lead_created: "Lead Created",

    // Other
    my_attachment: "Attachment",
    suggestion: "Suggestion",
    feedback: "Feedback",
    escalation: "Escalation",
    role: "Role",
    department: "Department",
    company: "Company",
    category: "Category",
    sub_category: "Sub Category",
    vendor: "Vendor",
    login: "Login",
    logout: "Logout",
    system: "System",
  };

  return (
    typeNames[type] ||
    type?.replace(/_/g, " ")?.replace(/\b\w/g, (l) => l.toUpperCase()) ||
    "Notification"
  );
};

/**
 * Check if a notification type exists in the mapping
 * @param {string} type - The notification type
 * @returns {boolean}
 */
export const isValidNotificationType = (type) => {
  return !!NOTIFICATION_TYPE_ROUTES[type] || !!DEFAULT_ROUTES[type];
};

/**
 * Get all available notification types
 * @returns {string[]}
 */
export const getAllNotificationTypes = () => {
  return [
    ...new Set([
      ...Object.keys(DEFAULT_ROUTES),
      ...Object.keys(NOTIFICATION_TYPE_ROUTES),
    ]),
  ];
};
